/**
 * Tiye Production workspace navigation.
 */

export const productionWorkspaceNav = [
  { name: 'ProductionOverview', to: '/production', label: 'Overview', icon: 'movie_filter', exact: true },
  { name: 'ProductionProjects', detailName: 'ProductionProjectDetail', to: '/production/projects', label: 'Projects', icon: 'folder_special' },
  { name: 'ProductionProductions', to: '/production/productions', label: 'Productions', icon: 'theaters' },
  { name: 'ProductionTeam', to: '/production/team', label: 'Team', icon: 'group', adminOnly: true }
]

export const productionContextNav = [
  { name: 'ProductionDetailOverview', suffix: '', label: 'Overview', icon: 'info' },
  { name: 'ProductionDetailPeople', suffix: '/people', label: 'People', icon: 'people' },
  { name: 'ProductionDetailScript', suffix: '/script', label: 'Script', icon: 'description' },
  { name: 'ProductionDetailScenes', suffix: '/scenes', label: 'Scenes', icon: 'movie' },
  { name: 'ProductionDetailShoot', suffix: '/shoot', label: 'Shoot', icon: 'event' },
  { name: 'ProductionDetailPlatforms', suffix: '/platforms', label: 'Platforms', icon: 'devices' },
  { name: 'ProductionDetailEditing', suffix: '/editing', label: 'Editing', icon: 'content_cut' },
  { name: 'ProductionDetailComments', suffix: '/comments', label: 'Comments', icon: 'chat' },
  { name: 'ProductionDetailRelease', suffix: '/release', label: 'Release', icon: 'publish' },
  { name: 'ProductionDetailCompleted', suffix: '/completed', label: 'Completed', icon: 'task_alt' },
  { name: 'ProductionDetailAnalytics', suffix: '/analytics', label: 'Analytics', icon: 'insights' }
]

export const productionStatusLabels = {
  planning: 'Planning',
  pre_production: 'Pre-production',
  shooting: 'Shooting',
  editing: 'Editing',
  ready_for_release: 'Ready for release',
  completed: 'Completed'
}

export const productionStatuses = Object.keys(productionStatusLabels)

export const editStatusLabels = {
  not_started: 'Not started',
  rough_cut: 'Rough cut',
  fine_cut: 'Fine cut',
  color: 'Color',
  sound: 'Sound',
  final: 'Final'
}

export const platformLabels = {
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  facebook: 'Facebook',
  x: 'X',
  tiye_app: 'Tiye app',
  tiye_news: 'Tiye News',
  tv: 'TV',
  radio: 'Radio',
  other: 'Other'
}

export const memberRoleLabels = {
  talent: 'Talent',
  director: 'Director',
  presenter: 'Presenter',
  crew: 'Crew'
}

export const productionStatusOptions = productionStatuses.map((status) => ({
  value: status,
  label: productionStatusLabels[status]
}))

export const productionStatusFilterOptions = [
  { value: '', label: 'All statuses' },
  ...productionStatusOptions
]

export const projectStatusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' }
]

export const projectStatusLabels = {
  active: 'Active',
  archived: 'Archived'
}

export const editStatusOptions = Object.entries(editStatusLabels).map(([value, label]) => ({ value, label }))

export const platformOptions = Object.entries(platformLabels).map(([value, label]) => ({ value, label }))

export const memberRoleOptions = Object.entries(memberRoleLabels).map(([value, label]) => ({ value, label }))

export const sceneSettingLabels = {
  interior: 'Interior',
  exterior: 'Exterior',
  mixed: 'Mixed'
}

export const sceneTimeLabels = {
  day: 'Day',
  night: 'Night',
  dawn: 'Dawn',
  dusk: 'Dusk',
  golden_hour: 'Golden hour'
}

export const sceneSettingOptions = [
  { value: '', label: 'Setting' },
  ...Object.entries(sceneSettingLabels).map(([value, label]) => ({ value, label }))
]

export const sceneTimeOptions = [
  { value: '', label: 'Time of day' },
  ...Object.entries(sceneTimeLabels).map(([value, label]) => ({ value, label }))
]

export const workspaceRoleOptions = [
  { value: 'member', label: 'Member' },
  { value: 'admin', label: 'Admin' }
]

export const memberStatusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
]

export function statusBadgeClass (status) {
  return `prod-badge prod-badge--${status || 'unknown'}`
}

export const productionProgressSteps = [
  { value: 'planning', label: 'Planning', short: 'Plan' },
  { value: 'pre_production', label: 'Pre-production', short: 'Pre' },
  { value: 'shooting', label: 'Shooting', short: 'Shoot' },
  { value: 'editing', label: 'Editing', short: 'Edit' },
  { value: 'ready_for_release', label: 'Ready for release', short: 'Release' },
  { value: 'completed', label: 'Completed', short: 'Done' }
]

export function productionProgressIndex (status) {
  const index = productionStatuses.indexOf(status)
  return index < 0 ? 0 : index
}

export function productionProgressPercent (status) {
  return Math.round(((productionProgressIndex(status) + 1) / productionStatuses.length) * 100)
}
